import { createContext } from 'react';

const apparelContext = createContext();

export default apparelContext;
